module.exports = __webpack_public_path__ + "/images/logo-cta-expansion-alpha.810f21a.png";